import { SAVE_ABLE_PAYMENT_METHODS } from '@constants/orders';
import { CreateOrderRequest, PaymentMethod } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function copy(
    state: WritableDraft<CreateOrderRequest>,
    payload: PayloadAction<CreateOrderRequest>,
) {
    Object.assign(state, payload.payload);
    state.discounts = [];
    state.giftPayments = [];
    state.prepaidCardPayments = [];
    state.useEmployeeDiscount = false;
    state.totalDiscount = 0;
    state.totalCouponDiscount = 0;
    state.totalPointDiscount = 0;

    // 현금영수증은 미신청으로 시작하고, 저장해 둔 정보는 선물·선불카드를 쓸 때 불러온다
    state.cashReceipt = undefined;
    state.cashReceiptError = undefined;
    state.saveCashReceipt = false;

    // 저장해 둔 요청사항·결제수단을 불러온다
    const note = window.localStorage.getItem('note');
    if (note) {
        state.note = note;
        state.saveNote = true;
    }
    const paymentMethod = getSavedPaymentMethod();
    if (paymentMethod) {
        state.paymentMethod = paymentMethod;
        state.savePaymentMethod = true;
    }
}

function getSavedPaymentMethod(): PaymentMethod | undefined {
    const data = window.localStorage.getItem('paymentMethod') as PaymentMethod | null;
    // 허용된 방법만 불러오기
    if (data && SAVE_ABLE_PAYMENT_METHODS.includes(data)) {
        return data;
    }
    return undefined;
}
